import { create } from "zustand";
import { Assistant } from "@/models/chatbot.ts";
import { catalogFetch } from "@/store/chatbot.ts";
import { DEFAULT_MODEL } from "@/components/chat/constants/appConstants.ts";

let catalogMap = new Map<string, Assistant>();

export async function loadAssistant(id: string): Promise<Assistant | null> {
  try {
    if (catalogMap.size == 0) {
      let resp = await catalogFetch();
      if (resp.list) {
        resp.list.forEach((item: Assistant) => {
          catalogMap.set(item.id, item);
        });
      }
    }

    let res = catalogMap.get(id);
    return res ? res : null;
  } catch (e) {}

  return null;
}

// Zustand
type ChatStore = {
  prevChatID: string | null;
  defaultModelID: string | null;
  defaultPrompt: string;
  setPrevChatID: (chatID: string | null) => void;
  setDefaultModelID: (modelID: string | null) => void;
  setDefaultPrompt: (prompt: string) => void;
};

export const useChatStore = create<ChatStore>()((set) => ({
  prevChatID: null,
  defaultModelID: DEFAULT_MODEL,
  defaultPrompt: "",
  setPrevChatID: (chatID: string | null) =>
    set((state) => ({
      prevChatID: chatID,
    })),
  setDefaultModelID: (modelID: string | null) =>
    set((state) => ({
      defaultModelID: modelID,
    })),
  setDefaultPrompt: (prompt: string) =>
    set((state) => ({
      defaultPrompt: prompt,
    })),
}));
